import { PropsWithChildren } from "react"
import { MutationCache, QueryClient, QueryClientProvider } from "react-query"
import { message } from "antd"

export const TimenotesQueryProvider = (props: PropsWithChildren) => {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
    </QueryClientProvider>
  )
}
